import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const JenisHcm = () => {
    const columns = [
        {
            name: 'ID HC Mutu',
            cell: row => row['idHcm']
        },
        {
            name: 'Kode HC Mutu',
            cell: row => row['kdHcm'] 
        },
        {
            name: 'Uraian HC Mutu',
            cell: row => row['uraianHcm'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listJenisHcm, setlistJenisHcm] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistJenisHcm = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listJenisHcm(null, null, page, size)
            setlistJenisHcm(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistJenisHcm([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistJenisHcm(0, 10)
    }, [getlistJenisHcm])

    const handleChangePage = (page) => {
        getlistJenisHcm(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listJenisHcm(null, null, page - 1, size)
        setlistJenisHcm(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Jenis HC Mutu</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listJenisHcm}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default JenisHcm